<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <el-button
        type="success"
        @click="visible = true"
        v-if="$store.state.role === 'admin'"
      >
        Excel Faylar
      </el-button>

      <template v-if="visible">
        <el-dialog v-model="visible" :show-close="false" width="500">
          <template #header="{ close, titleId, titleClass }">
            <div class="my-header">
              <h4 :id="titleId" :class="titleClass">Excel Faylar!</h4>
              <el-button type="danger" @click="close">
                <el-icon class="el-icon--left"><CircleCloseFilled /></el-icon>
                Yopish
              </el-button>
            </div>
          </template>
          <el-upload
            ref="uploadRef"
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeader"
            :multiple="false"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :limit="1"
            :on-exceed="onExceed"
            :on-success="onSuccessUpload"
            :on-error="onErrorUpload"
          >
            <template #trigger>
              <el-button style="width: 300px" type="primary">
                Hisob raqamlarni Excel orqali kiritish
              </el-button>
            </template>
          </el-upload>
          <el-upload
            ref="uploadRef"
            class="upload-demo"
            :action="uploadIdUrl"
            :headers="uploadHeader"
            :multiple="false"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :limit="1"
            :on-exceed="onExceed"
            :on-success="onSuccessUpload"
            :on-error="onErrorUpload"
          >
            <template #trigger>
              <el-button style="width: 300px" type="primary">
                ID raqamlarni Excel orqali kiritish
              </el-button>
            </template>
          </el-upload>

          <el-button
            type="success"
            style="width: 300px"
            @click="download('quarter-id-numbers/excel')"
            ><img src="@/assets/images/icons/download.svg" alt="" />
            Mavjud ID raqamlarni yuklab olish
          </el-button>

          <el-button
            type="success"
            style="width: 300px; margin-left: 0; margin-top: 5px"
            @click="download('quarter-acc-numbers/excel')"
            ><img src="@/assets/images/icons/download.svg" alt="" />
            Mavjud hisob raqamlarni yuklab olish
          </el-button>

          <el-button
            type="success"
            style="width: 300px; margin-left: 0; margin-top: 5px"
            @click="download('quarters-excel')"
            ><img src="@/assets/images/icons/download.svg" alt="" />
            Mahallalar listini yuklab olish
          </el-button>
        </el-dialog>
      </template>

      <el-select
        placeholder="Status tanlang"
        v-model="selectedStatus"
        @change="handleCurrentChange"
        :loading="regionsLoading"
      >
        <el-option
          v-for="stat in statuses"
          :key="stat.id"
          :value="stat.id"
          :label="stat.title"
        />
      </el-select>
      <el-select
        v-model="selectedRegion"
        v-if="$store.state.role === 'admin'"
        @change="getDistricts"
        :loading="regionsLoading"
      >
        <el-option
          v-for="region in regions"
          :key="region.id"
          :value="region.id"
          :label="region.title"
        />
      </el-select>
      <el-select
        v-model="selectedDistrict"
        @change="handleCurrentChange"
        v-if="
          $store.state.role === 'admin' ||
          $store.state.role === 'region_manager'
        "
        :loading="districtsLoading"
      >
        <el-option
          v-for="district in districts"
          :key="district.id"
          :value="district.id"
          :label="district.title"
        />
      </el-select>
      <el-button
        class="custom-btn"
        @click="() => this.$router.push({ name: 'QuarterAdd' })"
        type="primary"
        v-if="$store.state.role === 'admin'"
        >Qo'shish</el-button
      >
    </div>
    <el-table :data="quarters" border height="calc(100vh - 210px)">
      <el-table-column type="index" min-width="50" />
      <el-table-column prop="title" label="Nomi" min-width="250" />
      <el-table-column label="Hisob raqami" min-width="150">
        <template #default="scope">
          {{ scope.row.account_number || "Mavjud emas" }}
        </template>
      </el-table-column>
      <el-table-column label="Soliq nomi va kodi" min-width="200">
        <template #default="scope">
          {{ scope.row.id_number || "Mavjud emas" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="citizen_count"
        label="Aholi soni"
        min-width="150"
      />
      <el-table-column label="Status" min-width="150">
        <template #default="scope">
          {{
            scope.row.status == "ARCHIVE"
              ? "Arxiv"
              : scope.row.status == "ACTIVE"
              ? "Faol"
              : "Malumot kiritilmagan"
          }}
        </template>
      </el-table-column>
      <el-table-column width="200">
        <template #default="scope">
          <el-button
            size="small"
            @click="onEditQuarter(scope.row.id)"
            type="primary"
            >Tahrirlash</el-button
          >
          <el-button
            size="small"
            @click="onDeleteQuarter(scope.row.id)"
            type="danger"
            v-if="$store.state.role === 'admin'"
            >O'chirish</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

export default {
  name: "QuartersList",
  data() {
    return {
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/quarter-acc-numbers/sync-excel`,
      uploadIdUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/quarter-id-numbers/sync-excel`,
      uploadHeader: { Authorization: `${this.$store.state.accessToken}` },
      loading: false,
      visible: false,
      currentPage: 1,
      regionsLoading: false,
      statuses: [
        { id: "ARCHIVE", title: "Arxiv" },
        { id: "ACTIVE", title: "Faol" },
      ],
      selectedStatus: null,
      districtsLoading: false,
      regions: [],
      districts: [],
      quarters: [],
      selectedRegion: null,
      selectedDistrict: null,
    };
  },
  methods: {
    download(url) {
      this.loading = true;
      this.$http
        .get(`api/v1/${url}`, {
          responseType: "blob",
        })
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            })
          );
          const header = res.headers.get("Content-Disposition");
          const parts = header.split(";");
          let fileName = parts[1].split("=")[1];
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(({ response }) => {
          ElNotification({
            title: "Ogohlantirish",
            message:
              response.data.message ||
              "Ma'lumot yuklashda xatolik sodir bo'ldi!",
            type: "warning",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onEditQuarter(id) {
      this.$router.push({ name: "QuarterEdit", params: { id } });
    },
    onSuccessUpload() {
      console.log("success upload");
      this.loading = false;
      ElNotification.success({
        message: "Amaliyot muvaffaqiyatli bajarildi!",
      });
      this.getOrganizationsList();
    },
    onErrorUpload(error) {
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({ name: "Auth" });
      }
      ElNotification.error({
        message:
          JSON.parse(error?.message)?.message ||
          "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
        type: "error",
      });

      this.loading = false;
    },
    onExceed(files) {
      console.log("exceeds", files);
      // this.form.file[0] = files[0]
    },
    onDeleteQuarter(id) {
      ElMessageBox.confirm("Mahallani o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`/api/v1/quarters/${id}`)
            .then(() => {
              ElMessage({
                type: "success",
                message: "Mahalla o'chirildi",
              });
              this.getQuarterList();
            })
            .catch(() => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "O'chirish bekor qilindi",
          });
        });
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
        .get("/api/v1/regions")
        .then(({ data }) => {
          this.regions = data.regions;

          if (this.$store.state.role == "region_manager") {
            this.selectedRegion = this.$store.state.user.region_id;
          }
          this.getDistricts();
        })
        .catch(() => {})
        .finally(() => {
          this.regionsLoading = false;
        });
    },
    getDistricts() {
      this.districtsLoading = true;
      this.$http
        .get("/api/v1/districts", {
          params: {
            region_id: this.selectedRegion,
          },
        })
        .then(({ data }) => {
          this.districts = data.districts;
          // this.selectedDistrict = this.districts[0].id;
          this.handleCurrentChange();
        })
        .catch(() => {})
        .finally(() => {
          this.districtsLoading = false;
        });
    },
    handleCurrentChange() {
      this.$router.replace({
        query: {
          ...this.$route.query,
          district: this.selectedDistrict,
          region: this.selectedRegion,
          status: this.selectedStatus,
        },
      });
      this.getQuarterList();
    },
    getQuarterList() {
      this.loading = true;
      this.$http
        .get("/api/v1/quarters", {
          params: {
            district_id:
              this.$store.state.role !== "moderator"
                ? this.selectedDistrict
                : this.$store.state.user?.district_id,
            region_id:
              this.$store.state.role == "admin"
                ? this.selectedRegion
                : this.$store.state.user?.region_id,

            status: this.selectedStatus,
          },
        })
        .then(({ data }) => {
          this.quarters = data.quarters;
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.loading = true;

    if (this.$route.query.district) {
      this.selectedDistrict = parseInt(this.$route.query.district);
    }
    if (this.$route.query.region) {
      this.selectedRegion = parseInt(this.$route.query.region);
    }
    if (this.$route.query.status) {
      this.selectedStatus = this.$route.query.status
    }

    if (
      this.$store.state.role === "admin" ||
      this.$store.state.role === "region_manager"
    ) {
      this.getRegions();
    } else {
      this.handleCurrentChange();
    }
  },
};
</script>

<style scoped>
.header {
  display: flex;
  margin-bottom: 10px;
  gap: 10px;
  justify-content: flex-end;
}

.my-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
}
</style>
